// Keep this module identical in web and mobile. Read receipts in queryChannels
// are a limited snapshot; never present that snapshot as a complete viewer count.
export const mergeReadStates = (previous, incoming) => {
  const result = { ...previous };
  Object.entries(incoming).forEach(([id, receipt]) => {
    if (!result[id] || new Date(receipt.last_read) >= new Date(result[id].last_read)) {
      result[id] = { ...result[id], ...receipt };
    }
  });
  return result;
};

export const loadChannelReadReceipts = async (channel, isCancelled = () => false) => {
  const client = channel.getClient();
  const members = {};
  let read = {};
  // Use the query response directly: channel.query() also mutates the SDK's
  // message/read state, which can overwrite newer websocket events while paging.
  const url = `${client.baseURL}/channels/${encodeURIComponent(channel.type)}/${encodeURIComponent(channel.id)}/query`;
  for (let offset = 0; offset <= 10000; offset += 100) {
    if (isCancelled()) return null;
    const response = await client.post(url, {
      state: true,
      watch: false,
      messages: { limit: 0 },
      watchers: { limit: 0 },
      members: { limit: 100, offset },
    });
    if (isCancelled()) return null;
    if (!Array.isArray(response.members) || !Array.isArray(response.read)) {
      throw new Error("Channel read receipts are unavailable");
    }
    response.members.forEach((member) => {
      const id = member.user_id || member.user?.id;
      if (id) members[id] = member;
    });
    read = mergeReadStates(read, Object.fromEntries(
      response.read.filter((receipt) => receipt.user?.id)
        .map((receipt) => [receipt.user.id, receipt])
    ));
    if (response.members.length < 100) {
      // Some Stream configurations cap read state independently of members.
      // Fail closed instead of silently displaying a partial total in that case.
      const expected = response.channel?.member_count;
      if ((typeof expected === "number" && Object.keys(members).length < expected) ||
          Object.keys(members).some((id) => !read[id])) {
        throw new Error("Stream returned incomplete channel read receipts");
      }
      return { read, members };
    }
  }
  throw new Error("Channel membership exceeds the supported pagination range");
};
